import { render } from "./ResourceCentreView.vue?vue&type=template&id=3ea8a94e&scoped=true"
import script from "./ResourceCentreView.vue?vue&type=script&lang=js"
export * from "./ResourceCentreView.vue?vue&type=script&lang=js"

import "./ResourceCentreView.vue?vue&type=style&index=0&id=3ea8a94e&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea8a94e"]])

export default __exports__